import React, { useState, useEffect } from "react";
import request from "request";

const HandleLinkedInOauth = ({showImageHeader}) => {
    console.log()
    
    function getAccessToken(authCode){
        request.post({url:"https://www.linkedin.com/oauth/v2/accessToken",form:{
            grant_type:'authorization_code',
            code:authCode,
            redirect_uri:`${window.location.origin}/linkedin`,
            client_id:"78iz9k6vajbwyr",
            client_secret:"K62kuSubYUcGLx9G",
        }}, function(err,res,responseBody){
            if (err) {
                console.log(err);
            }
            else {
                console.log(responseBody);
                showImageHeader(true)
            }
        });
    }
  useEffect(() => {
    getAccessToken(window.location.href.split('=')[1].split('&')[0]);
  }, []);


  return (  
    <div>
        handleLinkedInOauth
        SASA
    </div>
  );
}

export default HandleLinkedInOauth